/** @jsxImportSource @emotion/react */
import React from 'react';

import { View, Pressable, Text, StyleSheet } from 'react-native-web';

import { One, Two, Three, ProgressLine } from 'Icons/Icons';
import Fonts from 'Themes/fonts';
import Colors from 'Themes/colors';
import { css } from '@emotion/react';

interface BreadcrumbProps {
    items: {
        key: string;
        label: string;
        onClick?(): void;
        disabledNumber?: boolean;
        disabledLine?: boolean;
    }[];
    style?: React.CSSProperties;
}

const Breadcrumbs = (props: BreadcrumbProps): JSX.Element => {
    const { items, style } = props;

    const renderBody = () => {
        return items.map((item, index) => {
            const { key, label, onClick, disabledNumber, disabledLine } = item;

            const isLastItem = index === (items.length - 1);

            const labelStyle = disabledNumber ? styles.itemTextDisabled : styles.itemText;

            const iconStyle = disabledNumber ? { fill: Colors.white, stroke: '#064E72', opacity: '0.3' } : { fill: '#064E72', stroke: Colors.white, opacity: 1 };

            const progressStyle = disabledLine ? { opacity: '0.3' } : { opacity: 1 };

            const renderIcon = () => {
                switch (index) {
                    case 0:
                        return <One style={iconStyle} />;
                    case 1:
                        return <Two style={iconStyle} />;
                    case 2:
                        return <Three style={{ ...iconStyle, alignItems: 'left' }} />;
                    default:
                        return null;
                }
            };

            return (
                <View style={styles.row} key={key}>
                    <div style={{ display: 'flex', alignItems: 'start', flexDirection: 'column' }}>
                        <div>
                            {renderIcon()}
                            {!isLastItem && (
                                <ProgressLine style={{ ...progressStyle, marginLeft: '1em', marginRight: '1em' }} css={styles.progressWidth} />
                            )}
                        </div>
                        <Pressable
                            style={{ ...styles.item, ...(disabledNumber ? { cursor: 'not-allowed' } : { cursor: 'pointer' }) }}
                            onPress={onClick}
                            disabled={disabledNumber}
                        >
                            <Text style={labelStyle}>
                                {label}
                            </Text>
                        </Pressable>
                    </div>
                </View>
            );
        });
    };

    return (
        <View style={[styles.container, style]}>
            {renderBody()}
        </View>
    );
};

const styles = {
    container: {
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '2.4em',
        flexDirection: 'row',
        flexWrap: 'wrap',
        paddingLeft: 50,
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    item: {
        alignItems: 'center',
    },
    itemText: {
        fontFamily: Fonts.primary,
        color: '#064E72',
        fontSize: 16,
        position: 'relative',
        left: '-40%',
    },
    itemTextDisabled: {
        fontFamily: Fonts.primary,
        fontSize: 16,
        color: '#064E72',
        opacity: '0.3',
        position: 'relative',
        left: '-40%',
    },
    progressWidth: css({
        '@media(min-width:300px)': {
            width: 60,
        },

        '@media(min-width:768px)': {
            width: 150,
        },

        '@media(min-width:1200px)': {
            width: 'auto',
        },
    }),
};

Breadcrumbs.defaultProps = {
    style: {},
};

export default Breadcrumbs;
